export const yes = Object.freeze({
  id: 1,
  name: 'yes',
  label: 'Si',
  value: true,
});
export const no = Object.freeze({
  id: 2,
  name: 'no',
  label: 'No',
  value: false,
});

export const options = Object.freeze({ yes, no });
export default [yes, no];
